// extracted by mini-css-extract-plugin
export default {"headerLink":"CM_oUPwa","svgIcon":"wnxXUuyr","headerTitle":"dIxE27qw"};